<div class="statistic-list">

  <mat-card-title>
    <span>{{ 'sources.configuration.statistic.processingLogRecords' | translate }}</span>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </mat-card-title>

  <mat-card-content>
    <table class="logs-table table table-bordered" *ngIf="logs">
      <thead>
      <tr>
        <th>{{ 'sources.configuration.statistic.placemarkId' | translate }}</th>
        <th>{{ 'sources.configuration.statistic.placemarkProcessingResult' | translate }}</th>
        <th>{{ 'sources.configuration.statistic.processingLogMessage' | translate }}</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let row of logs">
        <td>{{ row.PlacemarkId }}</td>
        <td>{{ processingResult[row.PlacemarkProcessingResult] }}</td>
        <td>{{ row.ProcessingLogMessage }}</td>
      </tr>
      </tbody>
    </table>

    <div *ngIf="!logs || logs.length === 0" class="stub">
      <h4 align="center">Empty list</h4>
    </div>

<!--    <div *ngIf="placemarkContent">-->
<!--      <mat-divider></mat-divider>-->

<!--      <mat-tab-group>-->
<!--        <mat-tab label="Placemark Data">-->
<!--          <pre>{{ placemarkContent | json }}</pre>-->
<!--        </mat-tab>-->
<!--        <mat-tab label="Description Data">-->
<!--          <pre>{{ placemarkContent.DescriptionData | json }}</pre>-->
<!--        </mat-tab>-->
<!--      </mat-tab-group>-->
<!--    </div>-->
  </mat-card-content>
</div>
